/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationV2Permissions
 */
export interface MatchOperationV2Permissions {
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationV2Permissions
     */
    canProtocol: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationV2Permissions
     */
    canCorrect: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationV2Permissions
     */
    canReopen: boolean;
}

/**
 * Check if a given object implements the MatchOperationV2Permissions interface.
 */
export function instanceOfMatchOperationV2Permissions(value: object): value is MatchOperationV2Permissions {
    if (!('canProtocol' in value) || value['canProtocol'] === undefined) return false;
    if (!('canCorrect' in value) || value['canCorrect'] === undefined) return false;
    if (!('canReopen' in value) || value['canReopen'] === undefined) return false;
    return true;
}

export function MatchOperationV2PermissionsFromJSON(json: any): MatchOperationV2Permissions {
    return MatchOperationV2PermissionsFromJSONTyped(json, false);
}

export function MatchOperationV2PermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2Permissions {
    if (json == null) {
        return json;
    }
    return {
        
        'canProtocol': json['canProtocol'],
        'canCorrect': json['canCorrect'],
        'canReopen': json['canReopen'],
    };
}

export function MatchOperationV2PermissionsToJSON(json: any): MatchOperationV2Permissions {
    return MatchOperationV2PermissionsToJSONTyped(json, false);
}

export function MatchOperationV2PermissionsToJSONTyped(value?: MatchOperationV2Permissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canProtocol': value['canProtocol'],
        'canCorrect': value['canCorrect'],
        'canReopen': value['canReopen'],
    };
}

